export const personalityKeys = {
	all: ["personality"] as const,
	byUserId: (userId: number) =>
		[...personalityKeys.all, "by-user-id", userId] as const,
	byFriendId: (friendId: number) =>
		[...personalityKeys.all, "by-friend-id", friendId] as const,
} as const
